import { FormGroup } from "@angular/forms";
import { OfferItemsFormComponent } from "./components/embedded/offer-items-form/offer-items-form.component";
import { PdfPreviewComponent } from "../issue/components/embedded/pdf-preview/pdf-preview.component";
import { OfferFormComponent } from "./components/embedded/offer-form/offer-form.component";
import { IOfferSummaryView, IOfferTransactionView } from "./interfaces";

export const createOfferTransactionIdentifier = 1;

export class OfferTransactionSetup {
    formGroupName: string;
    formGroup: FormGroup;
    view: IOfferTransactionView;
    summaryView: IOfferSummaryView;
    constructor(object) {
        this.formGroupName = object.formGroupName;
        this.view = object.view;
        this.summaryView = object.summaryView;
    }
}

export const OfferTransactionMap: { [key: number]: OfferTransactionSetup } = {
    1: new OfferTransactionSetup({
        formGroupName: 'offer',
        view: OfferFormComponent
    }),
    2: new OfferTransactionSetup({
        formGroupName: 'offerReport',
        view: PdfPreviewComponent
    }),
    3: new OfferTransactionSetup({
        formGroupName: 'bookOfferItems',
        view: PdfPreviewComponent
    }),
    4: new OfferTransactionSetup({
        formGroupName: 'createOfferItems',
        view: OfferItemsFormComponent
    })
};

export const OfferTransactionRoles = {
    'CreateOffer': 'CreateOffer',
    'EditOffer': 'EditOffer',
    'CreateOfferItem': 'CreateOfferItem'
};
